import React from 'react';

import './style.less';
import { range } from 'lodash';
import { Carousel } from 'antd';

import star from '_images/star.svg';

const LeadPageUserReview = ({ title, data }) => {
  return (
    <div className="sellers-review-section">
      <h2 className="font-semibold text-center">{title}</h2>
      <Carousel autoplay dots={false}>
        {data.map((d, i) => (
          <div className="pr-4 pl-4" key={i}>
            <div className="testimonial-wrap">
              {range(0, d.star).map((n) => (
                <span className="inline-block" key={n}>
                  <img height="14" width="14" alt="Rate" src={star} />
                </span>
              ))}
              <p className="os-text-17 mt-4">{d.content}</p>
            </div>
            <h4 className="os-text-17 font-semibold text-center">{d.author}</h4>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default LeadPageUserReview;
